import React from 'react';

export default function AboutSection() {
    return (
        <section className="py-16 md:py-24 px-4 md:px-6 relative overflow-hidden" id="about">
            {/* Subtle background accent */}
            <div className="absolute inset-0 z-0 overflow-hidden">
                <div className="absolute w-[500px] h-[500px] rounded-full bg-tertiary-container/30 -top-[150px] -left-[150px] blur-[100px]" />
                <div className="absolute w-[400px] h-[400px] rounded-full bg-primary-container/20 bottom-0 right-0 blur-[100px]" />
            </div>

            <div className="max-w-[1200px] mx-auto relative z-10">
                <div className="mb-16 reveal">
                    <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-container text-on-primary-container rounded-full text-[0.8125rem] font-semibold uppercase tracking-widest mb-4">
                        <i className="fa-solid fa-user"></i> About
                    </span>
                    <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-bold tracking-tight text-on-surface mb-2">Get to Know Me</h2>
                    <p className="text-[1.0625rem] text-on-surface-variant max-w-[560px] leading-relaxed">
                        A little about who I am, how I got here, and what keeps me going.
                    </p>
                </div>

                <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
                    {/* Text content */}
                    <div className="flex-1 reveal reveal-delay-1">
                        <div className="bg-surface-container rounded-2xl p-8 md:p-10 shadow-1">
                            <h3 className="text-2xl font-bold text-on-surface mb-1">Hello world!</h3>
                            <p className="text-on-surface-variant text-[0.9375rem] mb-6">It's nice that you got here to know about me.</p>

                            <div className="space-y-5">
                                <p className="text-[1.0625rem] text-on-surface-variant leading-[1.85]">
                                    It's been amazing to think how <span className="font-semibold text-on-surface">accidental and fortunate</span> it was to get into the field of software development and the thought still amazes me.
                                </p>
                                <p className="text-[1.0625rem] text-on-surface-variant leading-[1.85]">
                                    Starting from my college days, the interest to develop software applications has grown day by day which still keeps me alive in <span className="font-semibold text-on-surface">thinking new ideas</span> and trying to develop them regardless of the result.
                                </p>
                                <p className="text-[1.0625rem] text-on-surface-variant leading-[1.85]">
                                    Other than software development, my love for <span className="font-semibold text-on-surface">cricket</span> has been impeccable till date, and I love to explore places, going for <span className="font-semibold text-on-surface">bike rides</span>, <span className="font-semibold text-on-surface">drawing</span>, and <span className="font-semibold text-on-surface">photography</span>.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Interests grid */}
                    <div className="w-full lg:w-[380px] shrink-0 reveal reveal-delay-2">
                        <h3 className="text-[0.8125rem] font-semibold uppercase tracking-widest text-on-surface-variant mb-5 flex items-center gap-2">
                            <i className="fa-solid fa-heart text-[#e91e63]"></i> Things I Love
                        </h3>
                        <div className="grid grid-cols-2 gap-4">
                            {[
                                { icon: 'fa-solid fa-laptop-code', label: 'Software Dev', gradient: 'grad-1', desc: 'Building cool stuff' },
                                { icon: 'fa-solid fa-baseball-bat-ball', label: 'Cricket', gradient: 'grad-2', desc: 'Love the game' },
                                { icon: 'fa-solid fa-motorcycle', label: 'Bike Rides', gradient: 'grad-moto', desc: 'Open road therapy' },
                                { icon: 'fa-solid fa-pencil', label: 'Drawing', gradient: 'grad-6', desc: 'Pencil & paper' },
                                { icon: 'fa-solid fa-camera', label: 'Photography', gradient: 'grad-3', desc: 'Capturing moments' },
                                { icon: 'fa-solid fa-compass', label: 'Exploring', gradient: 'grad-4', desc: 'New places & people' },
                            ].map((interest, i) => (
                                <div
                                    key={i}
                                    className="group bg-surface-container rounded-2xl p-5 shadow-1 hover:shadow-2 hover:-translate-y-0.5 transition-all duration-300 ease-standard cursor-default"
                                >
                                    <div className={`${interest.gradient} w-10 h-10 rounded-xl flex items-center justify-center text-white text-lg mb-3 group-hover:scale-110 transition-transform duration-200`}>
                                        <i className={interest.icon}></i>
                                    </div>
                                    <h4 className="text-sm font-bold text-on-surface mb-0.5">{interest.label}</h4>
                                    <p className="text-xs text-on-surface-variant">{interest.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
